import { useSearchQuery } from '@/hooks/useSearchQuery';
import { FILTER_DIRECTORY_QUERY_KEY, FILTER_PARTNERS_QUERY_KEY, SEARCH_QUERY_KEY } from '../../consts/search-const';

export const useGetMainSearchQuery = () => {
  const [searchParams] = useSearchQuery();
  const search = searchParams.get(SEARCH_QUERY_KEY);
  const directory = searchParams.getAll(FILTER_DIRECTORY_QUERY_KEY);
  const partnersTypes = searchParams.getAll(FILTER_PARTNERS_QUERY_KEY);
  return { search, directory, partnersTypes };
};